class FakeStorage{
  data :{[key:string]:string}
  constructor(){
    this.data = {};
  }
  setItem(name :string,value :string){
    this.data[name]=value;
  }
  getItem(name:string){
    let result = this.data[name];
    if(result===undefined) return null; //localStorage/sessionStorage never return undefined
    return result;
  }
  removeItem(name:string){
    this.data[name]=undefined;
  }
}

var 
  local :FakeStorage|Storage = new FakeStorage(),
  session :FakeStorage|Storage = new FakeStorage();

try{
  localStorage.setItem('__test','__test');
  localStorage.removeItem('__test');
  local = localStorage;
}catch(e){}
try{
  sessionStorage.setItem('__test','__test');
  sessionStorage.removeItem('__test');
  session = sessionStorage;
}catch(e){}



export function sessionSet(key :string,value:string){
  session.setItem(key,value)
}
export function sessionGet(key:string){
  return session.getItem(key)
}
export function sessionRemove(key:string){
  session.removeItem(key)
}
export function localSet(key:string,value:string){
  local.setItem(key,value)
}
export function localGet(key:string){
  return local.getItem(key)
}
export function localRemove(key:string){
  local.removeItem(key)
}